// hooks/useIsOwn.ts — reactive "does the signed-in user own this record" check.
//
// Compares by id (User.id === Post.authorId / Comment.authorId — both are the
// username), NOT by handle. Handle and username can diverge (a display handle
// need not equal the account's username), so deriving ownership from the handle
// silently misidentified ownership — this is the single source of truth for it.

import { useSession } from './useSession';

/** True when the signed-in user's id matches the given authorId. False when signed out. */
export function useIsOwn(authorId: string | null | undefined): boolean {
  const { currentUser } = useSession();
  return currentUser !== null && currentUser.id === authorId;
}
